import React from "react";

function Stats() {
  return (
    <div class="counter">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div id="counter">
              <div class="cell">
                <i class="fas fa-users"></i>
                <div class="counter-value number-count" data-count="231">
                  200
                </div>
                <p class="counter-info">Happy Users</p>
              </div>
              <div class="cell">
                <i class="fas fa-code green"></i>
                <div class="counter-value number-count" data-count="385">
                  8
                </div>
                <p class="counter-info">Matches Made</p>
              </div>
              <div class="cell">
                <i class="fas fa-star red"></i>
                <div class="counter-value number-count" data-count="159">
                  180
                </div>
                <p class="counter-info">Good Reviews</p>
              </div>
              <div class="cell">
                <i class="fas fa-comments yellow"></i>
                <div class="counter-value number-count" data-count="127">
                  4
                </div>
                <p class="counter-info">Case Studies</p>
              </div>
              <div class="cell">
                <i class="fas fa-rocket blue"></i>
                <div class="counter-value number-count" data-count="211">
                  50
                </div>
                <p class="counter-info">Orders Received</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Stats;
